import Label from './Label';
import useTaskBadgeCount from '../hooks/useTaskBadgeCount';

/**
 * Renders a red badge showing the count of overdue + due-today tasks.
 * Used as the `info` prop on the Tasks nav item in NavConfig.
 * Returns null when count is 0 or tasks-v2 is not enabled.
 */
export default function TaskBadge() {
    const count = useTaskBadgeCount();

    if (!count) return null;

    return (
        <Label
            color="error"
            variant="filled"
            sx={{
                borderRadius: '10px',
                fontSize: '10px',
                height: 18,
                minWidth: 18,
                px: 0.5,
            }}
        >
            {count > 99 ? '99+' : count}
        </Label>
    );
}
